/**
 * Saudi formatting helpers for Employee Portal views.
 */
import { formatBrandMoney, getBrandLocale } from '../../shared/utils/brandCurrency';

/** ar-SA Gregorian date for portal tables and detail views. */
export function formatPortalDate(value, language = 'ar') {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(getBrandLocale(language), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/** Hijri date (Islamic calendar) for holidays and announcements. */
export function formatPortalHijriDate(value, language = 'ar') {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return d.toLocaleDateString(getBrandLocale(language), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      calendar: 'islamic',
    });
  } catch {
    return '';
  }
}

/** Gregorian + Hijri for Saudi holiday announcements. */
export function formatPortalDateWithHijri(value, language = 'ar') {
  const greg = formatPortalDate(value, language);
  const hijri = formatPortalHijriDate(value, language);
  if (!hijri || greg === '—') return greg;
  return `${greg} (${hijri})`;
}

export { formatBrandMoney as formatPortalMoney };

/** Resolve a category/status option label from a value list. */
export function resolveOptionLabel(value, options, pl) {
  if (!value) return '—';
  const found = options.find((o) => o.value === value);
  return found ? pl(found.labelKey) : value;
}
